import { useState } from 'react';
import { FileDown, Printer } from 'lucide-react';
import styles from './ExportButtons.module.css';

export function ExportCSVButton({ exportFn, onError, onClick, disabled, variant = 'default' }) {
  const [exporting, setExporting] = useState(false);

  async function handleClick() {
    if (exportFn) {
      setExporting(true);
      onError?.('');
      try {
        await exportFn();
      } catch (err) {
        onError?.(err.message || 'Export failed');
      } finally {
        setExporting(false);
      }
    } else {
      onClick?.();
    }
  }

  const btnClass = variant === 'list' ? styles.listBtn : styles.btn;
  const isDisabled = exportFn ? exporting : (disabled ?? false);

  return (
    <button className={btnClass} onClick={handleClick} disabled={isDisabled}>
      <FileDown size={12} strokeWidth={1.5} />
      {exporting ? 'Exporting…' : 'Export CSV'}
    </button>
  );
}

export function ExportPDFButton({ onClick, disabled }) {
  return (
    <button className={styles.btn} onClick={onClick} disabled={disabled}>
      <Printer size={12} strokeWidth={1.5} />
      Export to PDF
    </button>
  );
}
